import {
  AccordionItem,
  List,
  Stack,
  Text,
  TextLink,
} from 'braid-design-system';

import { useLocalized } from 'src/utils/hooks/useLocalized';

export const Support = () => (
  <AccordionItem id="support" label="Support">
    <List type="number" start={38}>
      <Stack space="medium">
        <Text>
          Any issues impacting the Advertiser’s use of any of our websites and
          apps via the SEEK API are to be advised to us via the Contact Us form
          on the Partner Hub at{' '}
          <TextLink href="/contact">
            {useLocalized({
              AU: 'https://talent.seek.com.au/contactus',
              NZ: 'https://talent.seek.co.nz/contactus',
            })}
          </TextLink>{' '}
          within 1 hour of the issue being detected. Support requests must
          clearly describe:
        </Text>
        <List type="alpha">
          <Text>an assessment of the impact to the Advertiser;</Text>
          <Text>the cause of the issue (if known);</Text>
          <Text>the duration of the issue;</Text>
          <Text>
            the expected timeframe to resolve the issue (if known); and
          </Text>
          <Text>
            any supporting logging data that can assist for diagnostic purposes.
          </Text>
        </List>
      </Stack>
    </List>
  </AccordionItem>
);
